import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Register from '@/components/Register'
import forgetPassWord from '@/components/forgetPassWord'
import modifyPassword from '@/components/modifyPassword'
Vue.use(Router)

export default new Router({
  // mode:'history',
  base:'/ykfcjypt/',//部署时需要放开
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/forgetPassWord',
      name: 'forgetPassWord',
      component: forgetPassWord
    },
    {
      path: '/modifyPassword',
      name: 'modifyPassword',
      component: modifyPassword
    },
    {
      path: '/main',
      component: () => import('@/components/Main'),
      hidden: true,
      children: [
        {
          path: '/my',
          name: '个人中心',
          component: () => import('@/components/grzx/index'),
          meta: ['个人中心']
        },
        {
          path: '/spf',
          name: '商品房',
          component: () => import('@/components/spf/index'),
          hidden: true,
          meta: ['商品房']
        },
        {
          path: '/spf/spfxq',
          name: '商品房详情',
          component: () => import('@/components/spf/respfxq'),
          meta: ['商品房', '商品房详情']
        },
        {
          path: '/spf/lpfyxq',
          name: '房源详情',
          component: () => import('@/components/spf/lpfyxq'),
          meta: ['商品房','楼盘房源', '房源详情']
        },
        {
          path: '/clf',
          name: '存量房(二手房)',
          component: () => import('@/components/clf/index'),
          hidden: true,
          meta: ['存量房(二手房)']
        },
        {
          path: '/clf/clfxq',
          name: '存量房(二手房)详情',
          component: () => import('@/components/clf/clfxq'),
          hidden: true,
          meta: ['存量房(二手房)', '存量房(二手房)详情']
        },
        {
          path: '/zlfw',
          name: '出租列表',
          component: () => import('@/components/zlfw/index'),
          hidden: true,
          meta: ['房屋租赁']
        },
        {
          path: '/zlfw/zlxq',
          name: '租赁详情',
          component: () => import('@/components/zlfw/zlxq'),
          hidden: true,
          meta: ['房屋租赁', '房屋租赁详情']
        },
        {
          path: '/qz_list',
          name: '求租列表',
          component: () => import('@/components/zlfw/qzlb'),
          hidden: true,
          meta: ['房屋租赁']
        },
        {
          path: '/xxgk',
          name: '信息公开',
          component: () => import('@/components/xxgk/index'),
          hidden: true,
          meta: ['信息公开']
        },
        {
          path: '/xxgk/xxxq',
          name: '信息详情',
          component: () => import('@/components/xxgk/xxxq'),
          hidden: true,
          meta: ['信息公开', '信息公开详情']
        },
        {
          path: '/jjjggl',
          name: '经纪机构管理',
          component: () => import('@/components/jjjggl/index'),
          hidden: true,
          meta: ['经纪机构管理'],
        },
        {
          path: '/jjjggl/jjjgbasq',
          name: '经纪机构备案申请',
          component: () => import('@/components/jjjggl/jjjgba'),
          hidden: true,
          meta: ['经纪机构管理','经纪机构备案申请']
        },
        {
          path: '/jjjggl/jjjgbabg',
          name: '经纪机构备案变更',
          component: () => import('@/components/jjjggl/jjjgba'),
          hidden: true,
          meta: ['经纪机构管理','经纪机构备案变更']
        },
        {
          path: '/jjjggl/jjjgbazx',
          name: '经纪机构备案注销',
          component: () => import('@/components/jjjggl/jjjgba'),
          hidden: true,
          meta: ['经纪机构管理','经纪机构备案注销']
        },
        {
          path: '/jjjggl/jjjgbanj',
          name: '经纪机构备案年检',
          // component: () => import('@/components/jjjggl/jjjgba'),
          hidden: true,
          meta: ['经纪机构管理','经纪机构备案年检']
        },
        {
          path: '/jjjggl/jgxxcx',
          name: '机构信息查询',
          component: () => import('@/components/jjjggl/jgxxcx'),
          hidden: true,
          meta: ['经纪机构管理','机构信息查询']
        },
        {
          path: '/jjjggl/jjrxxcx',
          name: '经纪人信息查询',
          component: () => import('@/components/jjjggl/jjrxxcx'),
          hidden: true,
          meta: ['经纪机构管理','经纪人信息查询']
        },
        {
          path: '/xq_list',
          name: '小区列表',
          component: () => import('@/components/xq/xqList'),
          hidden: true,
          meta: ['小区列表']
        },
        {
          path: '/xq_list/xqxq',
          name: '小区详情',
          component: () => import('@/components/xq/xqxq'),
          hidden: true,
          meta: ['小区列表','小区详情']
        },
        {
          path: '/jzfw',
          name: '家政服务',
          component: () => import('@/components/company/index'),
          hidden: true,
          meta: ['家政服务']
        },
        {
          path: '/chgs',
          name: '测绘公司',
          component: () => import('@/components/company/chgs'),
          hidden: true,
          meta: ['测绘公司']
        },
        {
          path: '/pggs',
          name: '评估公司',
          component: () => import('@/components/company/pggs'),
          hidden: true,
          meta: ['评估公司']
        },
        {
          path: '/zxsj',
          name: '装修公司',
          component: () => import('@/components/company/zxsj'),
          hidden: true,
          meta: ['装修公司']
        },
        {
          path: '/zxsj/xq',
          name: '装修公司详情',
          component: () => import('@/components/company/zxsjxq'),
          hidden: true,
          meta: ['装修公司','装修公司详情']
        },
        {
          path: '/jzjc',
          name: '家居建材',
          component: () => import('@/components/company/jzjc'),
          hidden: true,
          meta: ['家居建材']
        },
        {
          path: '/jzjc/jzjc_list',
          name: '家居建材列表',
          component: () => import('@/components/company/jzjcList'),
          hidden: true,
          meta: ['家居建材','家居建材列表']
        },
        {
          path: '/jzjc/jzjcxq',
          name: '家居建材详情',
          component: () => import('@/components/company/jzjcxq'),
          hidden: true,
          meta: ['家居建材','家居建材详情']
        },
        {
          path: '/zcfg',
          name: '政策法规',
          component: () => import('@/components/zcfg/index'),
          hidden: true,
          meta: ['政策法规']
        },
        {
          path: '/zcfg/xq',
          name: '政策法规详情',
          component: () => import('@/components/zcfg/xq'),
          hidden: true,
          meta: ['政策法规','政策法规详情']
        },
        {
          path: '/sfbz',
          name: '收费标准',
          component: () => import('@/components/sfbz/index'),
          hidden: true,
          meta: ['收费标准']
        },
        {
          path: '/sfbz/xq',
          name: '收费标准详情',
          component: () => import('@/components/sfbz/xq'),
          hidden: true,
          meta: ['收费标准','收费标准详情']
        },
        {
          path: '/bszn',
          name: '操作指南',
          component: () => import('@/components/bszn/index'),
          hidden: true,
          meta: ['操作指南']
        },
        {
          path: '/bszn/xq',
          name: '操作指南详情',
          component: () => import('@/components/bszn/xq'),
          hidden: true,
          meta: ['操作指南','操作指南详情']
        },
        {
          path: '/jjrxx',
          name: '经纪人信息',
          component: () => import('@/components/zjjg/zjjg'),
          hidden: true,
          meta: ['经纪人信息']
        },
        {
          path: '/zccz',
          name: '资产处置(顶账房)',
          component: () => import('@/components/zccz/index'),
          hidden: true,
          meta: ['资产处置(顶账房)']
        },
        {
          path: '/zccz/xq',
          name: '资产处置(顶账房)详情',
          component: () => import('@/components/zccz/xq'),
          hidden: true,
          meta: ['资产处置(顶账房)','资产处置详情']
        },
        {
          path: '/qgqz_list',
          name: '资产求购求租',
          component: () => import('@/components/zccz/qgqzIndex'),
          hidden: true,
          meta: ['资产求购求租']
        },
        {
          path: '/scjj',
          name: '公司简介',
          component: () => import('@/components/scjj'),
          hidden: true,
          meta: ['公司简介']
        },
        {
          path: '/csjj',
          name: '城市简介',
          component: () => import('@/components/csjj'),
          hidden: true,
          meta: ['城市简介']
        },
        {
          path: '/zlxz',
          name: '资料下载',
          component: () => import('@/components/zlxz/index'),
          hidden: true,
          meta: ['资料下载']
        },
        {
          path: '/zlxz/xq',
          name: '资料下载详情',
          component: () => import('@/components/zlxz/xq'),
          hidden: true,
          meta: ['资料下载','资料下载详情']
        },
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js